import { MenuItem, Box, Stack } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

interface IntegrationOptionProps {
  name: string;
  logo: ReactNode;
  description: string;
  actionButton?: ReactNode;
  actionsMenu?: ReactNode;
  additionalContent?: ReactNode;
}

export const IntegrationOption = ({
  name,
  logo,
  description,
  actionButton,
  actionsMenu,
  additionalContent,
}: IntegrationOptionProps) => {
  return (
    <MenuItem sx={{ padding: '16px' }}>
      <Stack width="100%">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 3,
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {logo}
            </Box>

            <Box
              sx={{
                flex: '1',
                textWrap: 'wrap',
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0,
              }}
            >
              <Typography variant="body-medium" color={colors.grey[900]}>
                {name}
              </Typography>
              <Typography variant="body" color={colors.grey[700]}>
                {description}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', marginTop: '4px' }}>
            {actionButton}
            {actionsMenu}
          </Box>
        </Box>
        {additionalContent && <Box sx={{ marginLeft: '48px' }}>{additionalContent}</Box>}
      </Stack>
    </MenuItem>
  );
};
